export default {
      id: "nav-logo-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "icons.svg#nav-logo",
      toString: function () {
        return this.url;
      }
    }